import { LitElement, html, css, t } from './-global.min.js'

class HHWishlistButton extends LitElement {
  static properties = {
    productId: { type: Number, attribute: 'product-id' },
    productTitle: { type: String, attribute: 'product-title' },
    firstVariantId: { type: Number, attribute: 'first-variant-id' },
    productHandle: { type: String, attribute: 'product-handle' },
    isLoggedIn: { type: Boolean },
    inWishlist: { type: Boolean },
    listId: { type: String },
    swat: { type: Object },
    pending: { type: Boolean }
  }

  constructor() {
    super()
    this.productId = ''
    this.firstVariantId = ''
    this.productHandle = ''
    this.isLoggedIn = false
    this.inWishlist = false
    this.listId = ''
    this.swat = null
    this.pending = false
  }

  connectedCallback() {
    super.connectedCallback()
    this.checkLoginStatus()
  }

  checkLoginStatus() {
    const onSwymLoadCallback = (swat) => {
      this.swat = swat

      const onSuccess = (response) => {
        this.isLoggedIn = response?.status === 'success' ? true : false
        const { data } = response
        if (data?.length > 0) {
          this.listId = data[0].lid
          this.checkWishlistStatus()
        } else {
          this.listId = null
        }
      }

      const onError = (error) => {
        console.log("Error while fetching user lists", error)
      }

      swat.wishlist?.fetchUserLists(onSuccess, onError)
    }

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = []
    }
    window.SwymCallbacks.push(onSwymLoadCallback)

    this.isLoggedIn = Shopify.customer ? true : false
  }

  async createList() {
    const listConfig = {
      "lname": "Personal List",
    }

    const onSuccess = (newList) => {
      console.log("Successfully created a new List", newList)
      this.listId = newList.lid
      this.addToList()
    }

    const onError = (error) => {
      console.log("Error while creating a List", error)
    }

    this.swat.createList(listConfig, onSuccess, onError)
  }

  async checkWishlistStatus() {
    const listConfig = {
      "lid": this.listId,
    }

    const onSuccess = (listContents) => {
      this.inWishlist = listContents.some(item => item.empi === this.productId)
      this.requestUpdate()
    }

    const onError = (error) => {
      console.log("Error fetching List Contents", error)
    }

    this.swat.fetchListCtx(listConfig, onSuccess, onError)
  }

  async toggleWishlist(event) {
    event.preventDefault()
    if (!this.isLoggedIn) {
      this.showLoginModal()
      return
    }

    this.inWishlist = !this.inWishlist
    this.pending = true
    this.requestUpdate()

    if (!this.listId) {
      this.createList()
    } else {
      if (this.inWishlist) {
        this.addToList()
      } else {
        this.removeFromList()
      }
    }
  }

  showLoginModal() {
    const loginModal = document.querySelector('#loginModal')
    if (loginModal) {
      setTimeout(() => {
        loginModal.open = true
      }, 0)
    }
  }

  async addToList() {
    const product = {
      epi: this.firstVariantId,
      empi: this.productId,
      du: `${window.location.origin}/products/${this.productHandle}`
    }

    const onSuccess = () => {
      this.inWishlist = true
      this.pending = false
      this.requestUpdate()

      const notificationMessageAdded = t('general.wishlist.notification_message_added')

      setTimeout(() => {
        this.dispatchEvent(
          new CustomEvent('wishlistProductToggled', {
            bubbles: true,
            composed: true,
            detail: {
              id: 'wishlist-notification',
              product_title: this.productTitle,
              message: notificationMessageAdded.replace('{{ product_title }}', this.productTitle),
              auto_close: 2500,
            },
          })
        )
      }, 300)
    }

    const onError = (error) => {
      console.log("Error while adding the Product to the List", error)
      this.inWishlist = false
      this.pending = false
      this.requestUpdate()
    }

    this.swat.addToList(this.listId, product, onSuccess, onError)
  }

  async removeFromList() {
    const product = {
      epi: this.firstVariantId,
      empi: this.productId,
      du: `${window.location.origin}/products/${this.productHandle}`
    }

    const onSuccess = () => {
      this.inWishlist = false
      this.pending = false
      this.requestUpdate()

      const notificationMessageRemoved = t('general.wishlist.notification_message_removed')

      setTimeout(() => {
        this.dispatchEvent(
          new CustomEvent('wishlistProductToggled', {
            bubbles: true,
            composed: true,
            detail: {
              id: 'wishlist-notification',
              product_title: this.productTitle,
              product_id: this.productId,
              message: notificationMessageRemoved.replace('{{ product_title }}', this.productTitle),
              auto_close: 2500,
            },
          })
        )
      }, 300)
    }

    const onError = (error) => {
      console.log("Error while deleting the Product", error)
      this.inWishlist = true
      this.pending = false
      this.requestUpdate()
    }

    this.swat.deleteFromList(this.listId, product, onSuccess, onError)
  }

  deleteAllLists(lists) {
    lists.forEach(list => {
      const onSuccess = (deletedListObj) => {
        console.log(`Successfully deleted the List, ${list.lid}`, deletedListObj)
      }

      const onError = (error) => {
        console.log(`Error while deleting the List, ${list.lid}`, error)
      }

      this.swat.deleteList(list.lid, onSuccess, onError)
    })
  }

  render() {
    return html`
      <hh-broadcast on='wishlistProductToggled' event='modal' class='block hh-broadcast'>
        <hh-button
          icon-only
          underline="false"
          class="card__inner__wishlist__icon icon-hover js-add-to-wishlist ${this.inWishlist ? ' is-active' : ''}"
          theme="tertiary"
          aria-label="${this.inWishlist ? 'Remove from wishlist' : 'Add to wishlist'}"
          @click="${this.toggleWishlist}"
        >
          <span class="icon-not-hover">
            <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="path-1-inside-1_329_1695" fill="white">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M12.161 2.03029L12 2.19133L11.839 2.03035C9.13033 -0.677128 4.73967 -0.676753 2.03145 2.03147C-0.677149 4.74007 -0.677149 9.13157 2.03145 11.8402L11.2061 21.0148C11.6462 21.4549 12.3598 21.4549 12.7999 21.0148L20.5293 13.2854C20.5591 13.2557 20.5876 13.2251 20.6149 13.1938L21.9686 11.8401C24.6772 9.13155 24.6772 4.74005 21.9686 2.03145C19.2604 -0.676762 14.8697 -0.677152 12.161 2.03029ZM12 5.01976L10.4259 3.44568C8.49838 1.51813 5.37321 1.51814 3.44566 3.44568C1.51811 5.37323 1.51811 8.4984 3.44566 10.426L12.003 18.9833L19.1113 11.875L19.1525 11.8278L20.5544 10.4259C22.4819 8.49838 22.4819 5.37321 20.5544 3.44566C18.6268 1.51811 15.5016 1.51811 13.5741 3.44566L12 5.01976Z"/>
              </mask>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M12.161 2.03029L12 2.19133L11.839 2.03035C9.13033 -0.677128 4.73967 -0.676753 2.03145 2.03147C-0.677149 4.74007 -0.677149 9.13157 2.03145 11.8402L11.2061 21.0148C11.6462 21.4549 12.3598 21.4549 12.7999 21.0148L20.5293 13.2854C20.5591 13.2557 20.5876 13.2251 20.6149 13.1938L21.9686 11.8401C24.6772 9.13155 24.6772 4.74005 21.9686 2.03145C19.2604 -0.676762 14.8697 -0.677152 12.161 2.03029ZM12 5.01976L10.4259 3.44568C8.49838 1.51813 5.37321 1.51814 3.44566 3.44568C1.51811 5.37323 1.51811 8.4984 3.44566 10.426L12.003 18.9833L19.1113 11.875L19.1525 11.8278L20.5544 10.4259C22.4819 8.49838 22.4819 5.37321 20.5544 3.44566C18.6268 1.51811 15.5016 1.51811 13.5741 3.44566L12 5.01976Z" fill="#646464"/>
              <path d="M12 5.01976L10.5858 6.43397L12 7.84819L13.4142 6.43397L12 5.01976ZM10.4259 3.44568L11.8401 2.03147L11.8401 2.03147L10.4259 3.44568ZM3.44566 3.44568L4.85987 4.8599L4.85987 4.8599L3.44566 3.44568ZM3.44566 10.426L4.85987 9.01174L3.44566 10.426ZM12.003 18.9833L10.5888 20.3975L12.003 21.8117L13.4172 20.3975L12.003 18.9833ZM19.1113 11.875L20.5256 13.2892L20.5738 13.241L20.6186 13.1896L19.1113 11.875ZM19.1525 11.8278L17.7383 10.4136L17.6901 10.4618L17.6452 10.5132L19.1525 11.8278ZM20.5544 10.4259L19.1402 9.01172V9.01172L20.5544 10.4259ZM20.5544 3.44566L21.9686 2.03145V2.03145L20.5544 3.44566ZM13.5741 3.44566L12.1599 2.03144L12.1599 2.03144L13.5741 3.44566ZM12.161 2.03029L10.7472 0.615752L10.7468 0.616078L12.161 2.03029ZM12 2.19133L10.5858 3.60555L12 5.01976L13.4142 3.60554L12 2.19133ZM11.839 2.03035L13.2532 0.616133L13.2529 0.615818L11.839 2.03035ZM2.03145 11.8402L3.44566 10.426L3.44566 10.426L2.03145 11.8402ZM11.2061 21.0148L9.79188 22.429L9.79188 22.429L11.2061 21.0148ZM12.7999 21.0148L14.2142 22.429L14.2142 22.429L12.7999 21.0148ZM20.5293 13.2854L19.1151 11.8712L20.5293 13.2854ZM20.6149 13.1938L19.2007 11.7796L19.1525 11.8278L19.1077 11.8792L20.6149 13.1938ZM21.9686 11.8401L20.5544 10.4259V10.4259L21.9686 11.8401ZM21.9686 2.03145L23.3828 0.617236V0.617236L21.9686 2.03145ZM4.85987 4.8599C6.00637 3.7134 7.86522 3.7134 9.01171 4.85989L11.8401 2.03147C9.13155 -0.677129 4.74004 -0.677126 2.03145 2.03147L4.85987 4.8599ZM4.85987 9.01174C3.71338 7.86524 3.71338 6.0064 4.85987 4.8599L2.03145 2.03147C-0.677149 4.74007 -0.677149 9.13157 2.03145 11.8402L4.85987 9.01174ZM13.4172 17.5691L4.85987 9.01174L2.03145 11.8402L10.5888 20.3975L13.4172 17.5691ZM17.6971 10.4608L10.5888 17.5691L13.4172 20.3975L20.5256 13.2892L17.6971 10.4608ZM17.6452 10.5132L17.6041 10.5604L20.6186 13.1896L20.6598 13.1424L17.6452 10.5132ZM19.1402 4.85988C20.2867 6.00638 20.2867 7.86522 19.1402 9.01172L21.9686 11.8401C24.6772 9.13155 24.6772 4.74005 21.9686 2.03145L19.1402 4.85988ZM14.9883 4.85987C16.1348 3.71338 17.9936 3.71337 19.1402 4.85988L21.9686 2.03145C19.26 -0.677146 14.8685 -0.677152 12.1599 2.03144L14.9883 4.85987ZM13.2529 0.615818C9.76315 -2.87239 4.1064 -2.87191 0.617233 0.617256L3.44566 3.44568C5.37294 1.5184 8.49752 1.51814 10.4251 3.44488L13.2529 0.615818ZM0.617233 0.617256C-2.87241 4.1069 -2.87241 9.76474 0.617234 13.2544L3.44566 10.426C1.51811 8.4984 1.51811 5.37323 3.44566 3.44568L0.617233 0.617256ZM0.617233 13.2544L9.79188 22.429L12.6203 19.6006L3.44566 10.426L0.617233 13.2544ZM9.79188 22.429C11.0131 23.6502 12.993 23.6502 14.2142 22.429L11.3857 19.6006C11.7267 19.2597 12.2794 19.2597 12.6203 19.6006L9.79188 22.429ZM14.2142 22.429L21.9435 14.6997L19.1151 11.8712L11.3857 19.6006L14.2142 22.429ZM21.9435 14.6997C22.0055 14.6377 22.065 14.5739 22.1222 14.5084L19.1077 11.8792C19.1103 11.8762 19.1127 11.8736 19.1151 11.8712L21.9435 14.6997ZM22.0292 14.608L23.3828 13.2544L20.5544 10.4259L19.2007 11.7796L22.0292 14.608ZM23.3828 13.2544C26.8724 9.76471 26.8724 4.10688 23.3828 0.617236L20.5544 3.44566C22.4819 5.37321 22.4819 8.49838 20.5544 10.4259L23.3828 13.2544ZM23.3828 0.617236C19.8936 -2.87191 14.2369 -2.87242 10.7472 0.615752L13.5749 3.44483C15.5025 1.51811 18.6271 1.51839 20.5544 3.44566L23.3828 0.617236ZM9.01171 4.85989L10.5858 6.43397L13.4142 3.60555L11.8401 2.03147L9.01171 4.85989ZM19.1402 9.01172L17.7383 10.4136L20.5667 13.242L21.9686 11.8401L19.1402 9.01172ZM13.4142 6.43397L14.9883 4.85987L12.1599 2.03144L10.5858 3.60555L13.4142 6.43397ZM10.7468 0.616078L10.5858 0.777117L13.4142 3.60554L13.5753 3.4445L10.7468 0.616078ZM10.4248 3.44456L10.5858 3.60555L13.4142 0.777116L13.2532 0.616133L10.4248 3.44456Z" fill="#646464" mask="url(#path-1-inside-1_329_1695)"/>
            </svg>
          </span>
          <span class="icon-is-hover">
            <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.9686 2.03145C19.26 -0.677146 14.8685 -0.677152 12.1599 2.03144L12 2.19133L11.8401 2.03147C9.13155 -0.677128 4.74004 -0.677126 2.03145 2.03147C-0.677149 4.74007 -0.677149 9.13157 2.03145 11.8402L11.2061 21.0148C11.6462 21.4549 12.3598 21.4549 12.7999 21.0148L20.5293 13.2854C20.5591 13.2557 20.5876 13.2251 20.6149 13.1938L21.9686 11.8401C24.6772 9.13155 24.6772 4.74005 21.9686 2.03145Z" fill="#ED1B2F"/>
            </svg>
          </span>
        </hh-button>
      </hh-broadcast>
    `
  }

  static styles = css`
    .icon-not-hover,
    .icon-is-hover {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      max-height: 24px;
      height: 24px;
      align-self: center;
    }
    .icon-is-hover {
      display: none;
    }
    .js-add-to-wishlist.is-active .icon-not-hover {
      display: none;
    }
    .js-add-to-wishlist.is-active .icon-is-hover {
      display: flex;
    }
    .js-add-to-wishlist:hover .icon-not-hover {
      display: none;
    }
    .js-add-to-wishlist:hover .icon-is-hover {
      display: flex;
    }
    .hh-broadcast{
      max-height: 24px;
    }
  `
}

if (!customElements.get('hh-wishlist-button')) {
  customElements.define('hh-wishlist-button', HHWishlistButton);
}
